// extracted by mini-css-extract-plugin
module.exports = {"flexblocks":"NewsBlockStyles_flexblocks__G_l6a","imgclip":"NewsBlockStyles_imgclip__M4Vxo","button":"NewsBlockStyles_button__16k_0"};